import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCarouselPharmacyStore = create(
	persist(
		(set) => ({
			pharmacy:null,
			root_pharmacy: null,
			data: null,
			platform: null,
			currentInfo: null,
			originProducts: null,
			setPharmacy: (pharmacy) => set({ pharmacy: pharmacy }),
			setRootPharmacy: (pharmacy) => set({ root_pharmacy: pharmacy }),
			setData: (data) => set({ data: data }),
			setPlatform: (platform) => set({ platform: platform }),
			setCurrentInfo: (data) => set({ currentInfo: data }),
			setOriginProducts: (products) => set({ originProducts: products }),
			resetCarouselPharmacyStore: () =>
				set({
					pharmacy: null,
					root_pharmacy: null,
					data: null,
					platform: null,
					currentInfo: null,
					originProducts: null,
				}),
		}),

		{
			name: 'carouselPharmacyStorage',
			getStorage: () => sessionStorage,
		},
	),
);
